import React, { useState } from "react";
import { Link, useOutletContext, useParams } from "react-router-dom";
import { Button, Form, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faAngleRight,
  faAnglesRight,
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import SetupWizardIcon from "../../assets/icons/template_helper.svg2";
import TemplateRec from "../../assets/icons/template_rec.svg2";
import boomColouredIcon from "../../assets/boom_coloured.png";
import TickIcon from "../../assets/icons/tick.svg2";
import LogicIcon from "../../assets/icons/library_logic.svg2";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import HelpButton from "../HelpContent/HelpButton";
import TemplateFeatures from "../Dashboard/TemplateFeatures";
import timezones from "../Builder/nodes/Logic/timezones";
import Subheading from "../Common/Subheading";
import MyIcon from "../Common/MyIcon";

function ProjectSetupWizard() {
  const [projectData, setProjectData] = useOutletContext();
  const { countries, defaultCountry, defaultTZ } = JSON.parse(
    document.querySelector("#app").dataset.page
  ).props;

  const { page } = useParams();
  const [answers, setAnswers] = useState({});
  const availableQuestions = [
    {
      id: "1",

      title: "Question title here?",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum beatae molestiae sed ullam qui ",
      inputType: "select",
      options: [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
      ],
    },
    {
      id: "2",
      title: "Question two title here?",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum beatae molestiae sed ullam qui ",
      inputType: "select",
      options: [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
      ],
    },
    {
      id: "3",
      title: "Question three title here?",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum beatae molestiae sed ullam qui ",
      inputType: "select",
      options: [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
      ],
    },
    {
      id: "4",
      title: "Multiselect questions here?",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum beatae molestiae sed ullam qui ",
      inputType: "select",
      isMulti: true,
      options: [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
      ],
    },
    {
      id: "5",
      title: "Question with a slider?",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum beatae molestiae sed ullam qui ",
    },
    {
      id: "6",
      title: "Multiselect question here?",
      description:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum beatae molestiae sed ullam qui ",
      isMulti: true,
    },
  ];

  return (
    <>
      <div className="d-flex align-items-center">
        <MyIcon Icon={SetupWizardIcon} />
        <div className="ms-3">
          <div className="fw-bold fs-2">
            Q&A Setup Wizard <HelpButton helpKey="project-setup-wizard" />
          </div>
          <div className="text-secondary">
            Lorem ipsum dolor sit amet consectetur, adipisicing elit.
          </div>
        </div>
      </div>
      <hr className="mt-4" />

      {page === "attributes" && (
        <>
          <div className="row my-3 mx-0">
            <div className="offset-md-2 col-md-4 border-end border-1">
              <div className="row">
                <div className="offset-md-2 col-md-9">
                  {[
                    {
                      label: (
                        <span>
                          Project label <HelpButton helpKey="project-label" />
                        </span>
                      ),
                      field: "Label",
                    },
                    {
                      label: (
                        <span>
                          Project reference{" "}
                          <HelpButton helpKey="project-reference" />
                        </span>
                      ),
                      field: "Reference",
                    },
                  ].map((i) => (
                    <div className="mb-4" key={i.field}>
                      <h5 className="form-label fw-bold">{i.label}</h5>
                      <input
                        style={{ height: 40 }}
                        className="form-control mb-2"
                        type="text"
                        value={projectData?.[i.field] ?? ""}
                        onChange={(e) =>
                          setProjectData((prev) => ({
                            ...prev,
                            [i.field]: e.target.value,
                          }))
                        }
                      />
                    </div>
                  ))}
                  <div className="mb-4">
                    <h5 className="form-label fw-bold">
                      Project description{" "}
                      <HelpButton helpKey="project-description" />
                    </h5>
                    <textarea
                      maxLength={255}
                      className="form-control mb-2"
                      value={projectData?.Description ?? ""}
                      onChange={(e) =>
                        setProjectData((prev) => ({
                          ...prev,
                          Description: e.target.value,
                        }))
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="row">
                <div className="offset-md-1 col-md-9">
                  <div className="mb-4">
                    <h5 className="form-label fw-bold">
                      Status <HelpButton helpKey="project-status" />
                    </h5>
                    <Input
                      inputType="select"
                      isValidNewOption={() => false}
                      value={[projectData?.Status]}
                      onChange={(values) =>
                        setProjectData((prev) => ({
                          ...prev,
                          Status: values[0],
                        }))
                      }
                      options={[
                        {
                          value: "draft",
                          label: `Draft`,
                        },
                        {
                          value: "production",
                          label: `Production`,
                        },
                        {
                          value: "archived",
                          label: `Archived`,
                        },
                      ]}
                    />
                  </div>
                  <div className="mb-4">
                    <h5 className="form-label fw-bold ">
                      Default time zone{" "}
                      <HelpButton helpKey="project-default-timezone" />
                    </h5>
                    <Input
                      inputType="select"
                      isValidNewOption={() => false}
                      value={[projectData?.TimeZone || ""]}
                      onChange={(values) =>
                        setProjectData((prev) => ({
                          ...prev,
                          TimeZone: values[0],
                        }))
                      }
                      options={[
                        {
                          value: "",
                          label: `Default from product settings: ${defaultTZ}`,
                        },
                        ...timezones.map((tz) => ({
                          value: tz.tzCode,
                          label: tz.label,
                        })),
                      ]}
                    />
                  </div>
                  <div className="mb-4">
                    <h5 className="form-label fw-bold">
                      Default Country{" "}
                      <HelpButton helpKey="project-default-country" />
                    </h5>
                    <Input
                      inputType="select"
                      isValidNewOption={() => false}
                      value={[projectData?.CountryISO || ""]}
                      onChange={(values) =>
                        setProjectData((prev) => ({
                          ...prev,
                          CountryISO: values[0],
                        }))
                      }
                      options={[
                        {
                          value: "",
                          label: `Default from product settings: ${defaultCountry.country_name}`,
                        },
                        ...countries.map((c) => ({
                          value: c.country_code,
                          label: c.country_name,
                        })),
                      ]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <div className="mx-auto my-2 d-flex align-items-center justify-content-center gap-4">
            <Link
              type="button"
              className="btn bg-purple-gradient rounded-pill pe-4 fw-bold"
              to="/create"
            >
              <span className="d-inline-block rounded-circle bg-body p-1 py-0 me-2">
                <FontAwesomeIcon icon={faAngleLeft} size="sm" />
              </span>
              Back
            </Link>
            <Link
              type="button"
              className="btn bg-purple-gradient rounded-pill ps-4 fw-bold"
              to="/create/project/wizard/setup"
            >
              Next
              <span className="d-inline-block rounded-circle bg-body py-0 p-1 ms-2">
                <FontAwesomeIcon icon={faAngleRight} size="sm" />
              </span>
            </Link>
            <Link
              type="button"
              className="btn bg-colored-reverse text-white rounded-pill ps-4 fw-bold"
              to="/create/project/builder"
            >
              SKIP TO THE BUILDER
              <span className="d-inline-block rounded-circle  p-1 py-0">
                <FontAwesomeIcon icon={faAnglesRight} size="sm" />
              </span>
            </Link>
          </div>
        </>
      )}

      {page === "setup" && (
        <>
          <div className="mt-4 d-flex justify-content-between">
            <div>
              <h3 className="fw-bold mb-1">
                Tell us about,Lorem ipsum dolor sit amet...
              </h3>
              <div className="text-secondary ">
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
              </div>
            </div>
            <div className="d-flex bg-purple-gradient p-3 align-items-center gap-5 rounded-3">
              <div className="ms-3">
                <div className="text-blue fw-bold">
                  Skip straight to canvas...
                </div>
                <div className="text-secondary ">
                  Lorem ipsum dolor sit amet consectetur.
                </div>
              </div>
              <div>
                <button className="btn btn-colored-reverse px-3 py-2 fw-bold rounded-pill">
                  CANVAS VIEW
                  <FontAwesomeIcon icon={faAnglesRight} className="ms-2" />
                </button>
              </div>
            </div>
          </div>
          <div className="row mt-5 justify-content-evenly">
            {availableQuestions.map((question) => (
              <div className="col-4 p-2">
                <div className=" d-flex  align-items-start p-4 bg-white rounded-3">
                  <div className="bg-icon rounded-circle me-3">
                    <img src={boomColouredIcon} width={45} />
                  </div>
                  <div className="me-3">
                    <h4 className="text-black fw-bold">{question.title}</h4>
                    <div className="text-secondary small">
                      {question.description}
                    </div>
                    <div className="mt-3">
                      <Input
                        value={answers[question.id] || []}
                        onChange={(v) => {
                          setAnswers((prev) => ({
                            ...prev,
                            [question.id]: v,
                          }));
                        }}
                        inputType={question.inputType}
                        options={question.options}
                        isMulti={question.isMulti}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <hr />
          <div className="mx-auto my-5 d-flex justify-content-center gap-4">
            <Link
              type="button"
              className="btn bg-purple-gradient rounded-pill pe-4 fw-bold"
              to="/create/project/wizard/attributes"
            >
              <span className="d-inline-block rounded-circle bg-body p-2 px-3 me-2">
                <FontAwesomeIcon icon={faChevronLeft} />
              </span>
              Back
            </Link>
            <Link
              type="button"
              className="btn bg-purple-gradient rounded-pill ps-4 fw-bold"
              to="/create/project/wizard/results"
            >
              Results
              <span className="d-inline-block rounded-circle bg-body p-2 px-3 ms-2">
                <FontAwesomeIcon icon={faChevronRight} />
              </span>
            </Link>
          </div>
        </>
      )}

      {page === "results" && (
        <>
          <div className="container">
            <Row>
              <div className="col-4 row">
                <div className="offset-2 col-10 mb-3">
                  <span className="bg-black text-white  px-3 py-1 rounded-pill text-spaced">
                    RESULTS
                  </span>
                </div>
                <div className="col-2">
                  <TemplateRec width={50} />
                </div>
                <div className="col-10">
                  <h5 className="text-black fw-bold">
                    Template recommendations...
                  </h5>
                  <div className="text-secondary small">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  </div>
                </div>
                <div className="offset-2 col-10 my-4">
                  <span className="fw-bold">
                    We recommend the following templates based on the answers
                    provided:
                  </span>

                  <div className=" d-flex">
                    <TickIcon width={25} className=" rounded-circle p-1" />
                    <h5 className="text-secondary p-2">
                      Lorem ipsum dolor sit amet consec
                    </h5>
                  </div>
                  <div className=" d-flex">
                    <TickIcon width={25} className=" rounded-circle p-1" />
                    <h5 className="text-secondary p-2">
                      Lorem ipsum dolor sit amet.
                    </h5>
                  </div>
                  <div className="d-flex">
                    <TickIcon width={25} className=" rounded-circle p-1" />
                    <h5 className="text-secondary p-2">
                      Lorem ipsum dolor sit.
                    </h5>
                  </div>
                  <div className="d-flex">
                    <TickIcon width={25} className=" rounded-circle p-1" />
                    <h5 className="text-secondary p-2">
                      Lorem ipsum dolor sit amet consec.
                    </h5>
                  </div>

                  <Button
                    className="btn btn-colored-reverse rounded-pill mt-4 "
                    size="sm"
                  >
                    <div className="d-flex align-items-center ">
                      <FontAwesomeIcon icon={faChevronLeft} />

                      <span className="my-0 mx-3">EDIT ANSWERS </span>
                    </div>
                  </Button>

                  <div className="fw-bold mt-4 pt-2">Please note:</div>

                  <span className="text-secondary">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Sequi aliquam odio recusandae numquam facere voluptate eos
                    omnis assumenda rem aperiam.
                  </span>
                </div>
              </div>
              <div className="col-4 bg-white text-center p-3 position-relative ">
                <span className="bg-colored-reverse rounded-pill text-spaced text-white px-3 py-1 position-absolute top-0 start-50 translate-middle ">
                  RECOMMENDED
                </span>
                <div className="text-center mt-4 mb-4">
                  <span className="bg-icon rounded-circle py-3">
                    <img src={boomColouredIcon} width={50} />
                  </span>
                </div>

                <h1 className="fw-bold">boomLogic Custom</h1>
                <div className="text-center  ">
                  <span className="text-secondary fw-bold">
                    A custom template our boomLogic system has created based on
                    our responses.
                  </span>
                </div>

                <div className="text-center   mt-3">
                  <span className=" fw-bold bg-info rounded-pill text-white  px-3 py-2">
                    <LogicIcon width={25} className="white " /> LOGIC READY
                  </span>
                </div>

                <div className="text-center  px-5 py-3">
                  <span className="fw-bold">
                    This template will setup the following for you:
                  </span>
                  <div className=" d-flex mt-3">
                    <TickIcon width={25} className=" rounded-circle p-1" />
                    <h5 className="text-secondary p-2">
                      Lorem ipsum dolor sit amet consec
                    </h5>
                  </div>
                  <div className=" d-flex">
                    <TickIcon width={25} className=" rounded-circle p-1" />
                    <h5 className="text-secondary p-2">
                      Lorem ipsum dolor sit amet.
                    </h5>
                  </div>
                  <div className="d-flex">
                    <TickIcon width={25} className=" rounded-circle p-1" />
                    <h5 className="text-secondary p-2">
                      Lorem ipsum dolor sit.
                    </h5>
                  </div>
                  <TemplateFeatures />
                </div>
              </div>
              <div className="col-4">
                <div className="offset-2 col-10 mb-3">
                  <span className="bg-black text-white  px-3 py-1 rounded-pill text-spaced">
                    REFINE
                  </span>
                </div>
                <div className=" offset-2 col-10">
                  <h3 className="text-black fw-bold">Customer Service Comms</h3>
                  <div className="text-secondary small">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  </div>
                </div>
                <div className="offset-2 col-10 mt-4">
                  <div>
                    <div className="fw-bold d-flex justify-content-between">
                      Budget for this project
                      <HelpButton helpKey="project-budget" />
                    </div>

                    <span className="fw-bold text-blue fs-1">£ 35,650</span>
                    <Form.Range className="bg-purple" />
                  </div>
                </div>
                <div className="offset-2 col-10 mt-4">
                  <div>
                    <div className="fw-bold d-flex justify-content-between">
                      Pertinent option
                      <HelpButton helpKey="project-pertinent-option" />
                    </div>

                    <span className="fw-bold text-blue fs-1">£ 5,500,000</span>
                    <span className="fw-bold text-blue">/month</span>
                    <Form.Range className="bg-purple" />
                  </div>
                  <div className="d-flex mt-3">
                    <div>
                      <div className="fw-bold">
                        Pertinent option <HelpButton />
                      </div>
                      <span className="text-secondary">
                        Lorem ipsum dolor, sit amet consectetur ad.
                      </span>
                    </div>
                    <Form.Check
                      type="switch"
                      id="pertinent-switch"
                      fs="2.5rem"
                    />
                  </div>
                  <hr />

                  <div>
                    <Button className="bg-black rounded-pill mt-4 ">
                      <div className="d-flex align-items-center ">
                        <TickIcon
                          width={25}
                          className=" purple rounded-circle p-1"
                        />
                        <span className="my-0 mx-3">
                          Apply Template & Start Build{" "}
                        </span>
                      </div>
                    </Button>
                    <br />
                    <span className="text-secondary small">
                      Lorem ipsum dolor, sit amet consectetur ad.
                    </span>
                  </div>
                </div>
              </div>
            </Row>
          </div>
          <hr />
          <div className="mx-auto my-5 d-flex justify-content-center gap-4">
            <Link
              type="button"
              className="btn bg-purple-gradient rounded-pill pe-4 fw-bold"
              to="/create/project/wizard/setup"
            >
              <span className="d-inline-block rounded-circle bg-body p-2 px-3 me-2">
                <FontAwesomeIcon icon={faChevronLeft} />
              </span>
              Back
            </Link>
          </div>
        </>
      )}
    </>
  );
}

export default ProjectSetupWizard;
